import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlersReturn } from '../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3149ROLES } from '../../../U3149';
import type { U3149WorkNatureFormRow } from '../../../U3149Service';

export type U3149WorkNatureFormToolbarHandlers = U2000FormStateHandlersReturn<U3149WorkNatureFormRow> & {
  addNewWorkNature: () => void;
  modifyWorkNature: () => void;
  deleteWorkNature: () => void | Promise<void>;
};

interface U3149WorkNatureFormToolBarProps {
  formStateHandlers: U3149WorkNatureFormToolbarHandlers;
}

export const U3149WorkNatureFormToolBar: React.FC<U3149WorkNatureFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3149ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewWorkNature();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3149ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyWorkNature();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3149ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteWorkNature();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
